<template>
  <div class="content-item flex align-items-center">
    <div class="content-item-label">选择疾病</div>
    <el-select
      v-model="diseaseId"
      filterable
      remote
      clearable
      size="mini"
      placeholder="请输入疾病"
      :remote-method="diseaseRemoteMethod"
      @change="writeChange"
      :loading="diseaseLoading">
      <el-option
        v-for="item in diseaseOptions"
        :key="item.diseaseId"
        :label="item.diseaseName"
        :value="item.diseaseId">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import {request} from "@/utils/axios";

export default {
  name: "selectDisease",
  props: ['functionIds','contentId'],
  data() {
    return {
      // 关联症状疾病
      diseaseLoading: false,
      diseaseOptions: [],
      diseaseId: '',
    }
  },
  methods: {
    writeChange(value) {
      if (value === '') {
        this.diseaseOptions = []
      } else {
        request(this.functionIds.validDiseaseRel,{
          tenantId: this.$commonJs.getTenantId(),
          diseaseId: value,
          contentId: this.contentId
        }).then((res)=>{
          console.log(res)
          if (res.code == '0000') {
            console.log(res)
          }
        }).catch(err=>{
          this.$message.error(err.msg);
          this.diseaseId = ''
        })
      }
    },
    //关联疾病症状搜索
    diseaseRemoteMethod(query) {
      if (query !== "") {
        this.diseaseLoading = true;
        request(this.functionIds.getRemote,{
          tenantId: this.$commonJs.getTenantId(),
          diseaseName: query
        })
          .then(res => {
            this.diseaseOptions = res?.data || [];
            this.diseaseLoading = false;
          })
          .catch(err => {
            this.diseaseOptions = [];
            this.diseaseLoading = false;
          });
      } else {
        this.diseaseOptions = [];
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
